module.exports = __webpack_public_path__ + "static/media/dininghallbackground.2545cd54.png";